import { ActionReducer, Action } from "@ngrx/store"
import { EnquiriesStore } from "@store/enquiries"
import { Enquiry } from "@models/enquiry"

export const enquiriesReducer: ActionReducer<EnquiriesStore> = (state: EnquiriesStore = new EnquiriesStore(), action: Action) => {

  let activeEnquiry, targetStep

  const s = EnquiriesStore.clone(state)

  switch(action.type) {
    case POPULATE_ENQUIRIES:
      s.enquiries = [...action.payload]
      return s

    case ADD_ENQUIRY:
      s.enquiries = [...action.payload, s.enquiries]
      s.activeEnquiry = action.payload
      return s 

    case REPLACE_ENQUIRY:
      const p = action.payload
      const enquiries = state.enquiries.map((e: Enquiry) => {
        if (e.id === p.id) { return p }
        return e
      })
      const active = state.activeEnquiry.id === p.id ? p : Enquiry.clone(state.activeEnquiry)
      const editable = state.editableEnquiry.id === p.id ? p : Enquiry.clone(state.editableEnquiry)
      return new EnquiriesStore(
        enquiries,
        active,
        editable,
        state.classes)

    case POPULATE_ACTIVE_ENQUIRY:
      s.activeEnquiry = action.payload
      return s

    case POPULATE_EDITABLE_ENQUIRY:
      s.editableEnquiry = action.payload
      return s

    case CREATE_ENQUIRY_FAILURE:
      s.editableEnquiry = 
        Enquiry.clone(Object.assign({}, state.editableEnquiry, action.payload))
      return s

    case RESET_ENQUIRY_ERRORS:
      s.editableEnquiry = 
        Enquiry.clone(Object.assign({}, action.payload, { errors: {} }))
      return s

    case POPULATE_ENQUIRY_CLASSES:
      s.classes = action.payload
      return s

    case ENQUIRY_ACTIVE_INCREMENT_STEP:
      targetStep = state.activeEnquiry.step + 1
      s.activeEnquiry =
        Enquiry.clone(Object.assign({}, state.activeEnquiry, { step: targetStep }))
      return s

    case ENQUIRY_ACTIVE_DECREMENT_STEP:
      targetStep = state.activeEnquiry.step - 1
      s.activeEnquiry =
        Enquiry.clone(Object.assign({}, state.activeEnquiry, { step: targetStep }))
      return s

    case ENQUIRY_ACTIVE_GO_TO_STEP:
      s.activeEnquiry =
        Enquiry.clone(Object.assign({}, state.activeEnquiry, { step: action.payload }))
      return s

    default:
      return s
  }
}

export const FETCH_ENQUIRIES = "FETCH_ENQUIRIES"
export const FETCH_ENQUIRIES_FAILURE = "FETCH_ENQUIRIES"
export const POPULATE_ENQUIRIES = "POPULATE_ENQUIRIES"
export const ADD_ENQUIRY = "ADD_ENQUIRY"
export const FETCH_ENQUIRY = "FETCH_ENQUIRY"
export const FETCH_ENQUIRY_BY_GUID = "FETCH_ENQUIRY_BY_GUID"
export const FETCH_ENQUIRY_FAILURE = "FETCH_ENQUIRY_FAILURE"
export const POPULATE_ACTIVE_ENQUIRY = "POPULATE_ACTIVE_ENQUIRY"
export const POPULATE_EDITABLE_ENQUIRY = "POPULATE_EDITABLE_ENQUIRY"
export const REPLACE_ENQUIRY = "REPLACE_ENQUIRY"
export const UPDATE_ENQUIRY = "UPDATE_ENQUIRY"
export const UPDATE_ENQUIRY_FAILURE = "UPDATE_ENQUIRY_FAILURE"
export const CREATE_ENQUIRY = "CREATE_ENQUIRY"
export const CREATE_ENQUIRY_FAILURE = "CREATE_ENQUIRY_FAILURE"
export const RESET_ENQUIRY_ERRORS = "RESET_ENQUIRY_ERRORS"
export const FETCH_ENQUIRY_CLASSES = "FETCH_ENQUIRY_CLASSES"
export const POPULATE_ENQUIRY_CLASSES = "POPULATE_ENQUIRY_CLASSES"
export const FETCH_ENQUIRY_CLASSES_FAILURE = "FETCH_ENQUIRY_CLASSES_FAILURE"
export const ENQUIRY_ACTIVE_INCREMENT_STEP = "ENQUIRY_ACTIVE_INCREMENT_STEP"
export const ENQUIRY_ACTIVE_DECREMENT_STEP = "ENQUIRY_ACTIVE_DECREMENT_STEP"
export const ENQUIRY_ACTIVE_GO_TO_STEP = "ENQUIRY_ACTIVE_GO_TO_STEP"
export const CONVERT_ENQUIRY_TO_CONTACT = "CONVERT_ENQUIRY_TO_CONTACT"
export const CONVERTED_ENQUIRY_TO_CONTACT = "CONVERTED_ENQUIRY_TO_CONTACT"
export const CONVERT_ENQUIRY_TO_CONTACT_FAILURE = "CONVERT_ENQUIRY_TO_CONTACT_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/enquiries.ts